import styles from './SolidLoaders.module.css'

export const SolidCircularLoader = () => {
    return (
        <div className={styles.SolidCircularLoader}></div>
    )
}